let showValue;

export default {

    start(func, duration) {
        clearTimeout(showValue);

        showValue = setTimeout(() => func(),
            duration
        );
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/throttle.js